<app-header></app-header>

<!-- temporary-message section -->
<!-- <div class="temporary_alert" *ngIf="shouldShowMessage()">
  دوستان عزیز پومودورویی سلام! 👋
  <br />
  در حال رفع مشکلات وب اپلیکیشن پومودورو هستیم؛ از صبر و شکیبایی شما سپاسگزاریم.
  <br />
  از طریق چت آنلاینِ گوشه‌ی پایین، سمت راست شنوای نظرات شما هستیم :)
  <br />
  <div class="close_temporary_alert" (click)="closeMessage()">
    متوجه شدم؛ دیگه این پیام رو نمایش نده.
  </div>
</div> -->
<!-- End temporary-message section -->

<div id="main_app" class="container-fluid">
  <div class="container">
    <div id="pomodoro_timer" [ngClass]="{ break: pomodoroRepository.isBreak }">
      <!--      <div *ngIf="haveToken" class="todo_list_navigate_section" (click)="navigateToTodoList()">-->
      <!--        <mat-icon> list_alt</mat-icon>-->
      <!--      </div>-->
      <!--      <div *ngIf="!haveToken" class="todo_list_navigate_section" (click)="openPopUp()">-->
      <!--        <mat-icon> list_alt</mat-icon>-->
      <!--      </div>-->
      <div
        class="pomodoro_count"
        *ngIf="!haveToken && !pomodoroRepository.isBreak"
      >
        {{ "Pomodoro" | translate }} {{ pomodoroRepository.todayPomodoroCount }}
      </div>
      <div
        class="pomodoro_count"
        *ngIf="!haveToken && pomodoroRepository.isBreak"
      >
        {{ "Pomodoro" | translate }}
        {{ pomodoroRepository.todayPomodoroCount - 1 }}
      </div>
      <div
        class="pomodoro_count"
        *ngIf="haveToken && !pomodoroRepository.isBreak"
      >
        {{ "Pomodoro" | translate }} {{ pomodoroRepository.pomoCount }}
      </div>
      <div
        class="pomodoro_count"
        *ngIf="haveToken && pomodoroRepository.isBreak"
      >
        {{ "Pomodoro" | translate }} {{ pomodoroRepository.pomoCount - 1 }}
      </div>
      <div class="timer">{{ pomodoroRepository.getTimerString() }}</div>
      <div class="current_task" *ngIf="!pomodoroRepository.isBreak">
        {{ pomodoroRepository.getFirst().description }}
      </div>
      <div
        class="current_task"
        *ngIf="!haveToken && pomodoroRepository.isBreak"
      >
        {{ "Break" | translate }}
        {{ pomodoroRepository.todayPomodoroCount - 1 }}
      </div>
      <div class="current_task" *ngIf="haveToken && pomodoroRepository.isBreak">
        {{ "Break" | translate }} {{ pomodoroRepository.pomoCount - 1 }}
      </div>
      <div class="buttons_timer">
        <ng-container *ngIf="pomodoroRepository.status === 'stop'">
          <button
            (click)="pomodoroRepository.start()"
            class="start_button"
            [ngClass]="{ 'break-btn': pomodoroRepository.isBreak }"
          >
            {{ "Start" | translate }}
          </button>
        </ng-container>
        <button
          *ngIf="!pomodoroRepository.isBreak"
          (click)="pomodoroRepository.restart()"
          class="reset_button"
          [ngStyle]="{ cursor: pomodoroRepository.reo() }"
          [disabled]="
            pomodoroRepository.status === 'stop' &&
            pomodoroRepository.isBreak === false
          "
        >
          {{ "Restart" | translate }}
        </button>
        <button
          *ngIf="pomodoroRepository.isBreak"
          (click)="pomodoroRepository.restart()"
          class="reset_button"
          [ngStyle]="{ cursor: pomodoroRepository.reo() }"
          [disabled]="
            pomodoroRepository.status === 'stop' &&
            pomodoroRepository.isBreak === false
          "
        >
          {{ "Skip" | translate }}
        </button>
      </div>
    </div>
    <!-- #pomodoro_timer -->
    <div id="todo">
      <div class="main_title">
        <i class="icon-clipboard"></i>{{ "TodoList" | translate }} |
        <span class="getfo"
          >{{ pomodoroRepository.getAllToDoPomodoro() }} /
          {{ pomodoroRepository.getSumOfDurationsTodo() }}</span
        >
      </div>
      <div class="add_new_task">
        <form action="">
          <div class="cat_task">
            <input
              (change)="saveToCategories(this.myControl.value)"
              type="text"
              placeholder="{{ 'Category' | translate }}"
              matInput
              [formControl]="myControl"
              [matAutocomplete]="auto"
              [(ngModel)]="pomodoro.category"
              [value]="pomodoro.category"
              (keyup.enter)="focusTaskInput()"
            />
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option
                *ngFor="let category of pomodoroRepository.categories"
                [value]="category"
              >
                {{ category }}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div class="title_task">
            <input
              type="text"
              class="cat_task"
              [value]="pomodoro.description"
              #focus
              placeholder="{{ 'ShortDescription' | translate }}"
              [(ngModel)]="pomodoro.description"
              name="task.description"
              (keyup.enter)="addItem()"
            />
          </div>
          <div class="add_task_button">
            <button type="button" (click)="addItem()">
              <i class="icon-plus"></i>
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
      <!-- .add_new_task -->
      <div class="todolist">
        <div *ngIf="pomodoroRepository.todoPomodoros.length === 0">
          <div class="to_do_list_empty_box">
            <img
              src="assets/image/pomodoro-illustration.svg"
              alt="pomodoro-illustration"
            />
            <div class="title_to_do_list_empty_box">
              {{ "YourTaskListIsEmpty" | translate }}
            </div>
            <div class="excerpt_to_do_list_empty_box">
              {{ "DefineNewJob" | translate }}
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <ng-container *ngIf="pomodoroRepository.todoPomodoros.length !== 0">
          <div class="header_task">
            <div class="col_task col_task1">
              <i class="icon-list-ul"></i>{{ "Category" | translate }}
            </div>
            <div class="col_task col_task2">
              <i class="icon-bookmark"></i>{{ "ShortDescription" | translate }}
            </div>
            <button
              mat-button
              [matMenuTriggerFor]="sortList"
              class="col_task sort-list-icon float-left sort-button"
            >
              <img class="sort-icon" src="assets/image/sort.svg" alt="" />
            </button>
            <mat-menu #sortList="matMenu" class="customize-sort-menu">
              <button
                mat-menu-item
                class="customize-sort-menu-btn"
                *ngFor="let item of sortListItem"
                (click)="selectSort(item)"
                [ngClass]="{ 'disable-item': !item.isAvailable }"
              >
                <div>{{ item.title }}</div>
                <div *ngIf="item.isSelected && item.isAvailable">
                  <img src="assets/image/selected-in-sort.svg" alt="" />
                </div>
              </button>
            </mat-menu>
            <div class="clearfix"></div>
          </div>
          <!-- .task -->
          <div
            class="drag-drop example-list"
            cdkDropList
            #todoList="cdkDropList"
            [cdkDropListData]="pomodoroRepository.getTodoPomodoros()"
            [cdkDropListConnectedTo]="[todoList]"
            (cdkDropListDropped)="drop($event)"
          >
            <div
              class="task"
              *ngFor="let item of pomodoroRepository.getTodoPomodoros()"
              title="{{ 'تعداد پومودورو' | translate }}"
              cdkDrag
            >
              <div
                *ngIf="!item.isEdit"
                (click)="showInput(item)"
                class="col_task col_task1"
              >
                {{ item.category }}
              </div>
              <div
                *ngIf="item.isEdit"
                (keyup.enter)="backToDes(item)"
                class="col_task col_task1"
              >
                <input
                  class="input_v2"
                  (change)="saveToCategoriesTasks(item)"
                  type="text"
                  placeholder="{{ 'Category' | translate }}"
                  aria-label="Number"
                  matInput
                  [matAutocomplete]="auto"
                  (keyup.enter)="focusTaskInput()"
                  [(ngModel)]="item.category"
                  value="category"
                  [disabled]="toggleButton"
                  #categoryInput
                />
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option
                    *ngFor="let category of pomodoroRepository.categories"
                    [value]="category"
                  >
                    {{ category }}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="col_task col_task2">
                <div
                  class="task_desc"
                  *ngIf="!item.isEdit"
                  (click)="showInput(item)"
                >
                  {{ item.description }}
                </div>
                <div *ngIf="item.isEdit">
                  <input
                    type="text"
                    #focus
                    [disabled]="toggleButton"
                    id="desc"
                    (keyup.enter)="backToDes(item)"
                    class="edit-input"
                    placeholder="{{ 'Title' | translate }}"
                    [(ngModel)]="item.description"
                    name="task.description"
                  />
                </div>
              </div>
              <div
                class="col_task col_task3"
                title="{{ 'TaskFinishTime' | translate }}"
              >
                {{ pomodoroRepository.getPomoToDoDoneTime(item) }}
              </div>
              <div class="col_task col_task4 d-flex">
                <div class="counter-twins-wrapper w-28">
                  <div
                    class="counter-twins increase-counter"
                    (click)="increaseCount(item)"
                    title="{{ 'increasePomodoroCount' | translate }}"
                  >
                    +
                  </div>
                  <div
                    class="counter-twins decrease-counter"
                    (click)="decreaseCount(item)"
                    title="{{ 'decreasePomodoroCount' | translate }}"
                  >
                    -
                  </div>
                </div>
                <div class="w-28">
                  <button class="count_pomodoro">{{ item.count }}</button>
                </div>
              </div>
              <div class="col_task col_task5">
                <button
                  [matMenuTriggerFor]="menu"
                  class="more_option_button"
                  title="{{ 'OpenMenu' | translate }}"
                >
                  <i class="icon-ellipsis-h-alt"></i>
                </button>
                <mat-menu #menu="matMenu" class="task-menu">
                  <button
                    mat-menu-item
                    class="task-menu-btn"
                    (click)="removeItemFromTodo(item)"
                  >
                    <mat-icon>delete_forever</mat-icon>
                    <span class="icon-txt">{{ "DeleteTask" | translate }}</span>
                  </button>
                  <button
                    mat-menu-item
                    class="task-menu-btn"
                    (click)="showInput(item)"
                  >
                    <mat-icon>create</mat-icon>
                    <span class="icon-txt">{{ "EditTask" | translate }}</span>
                  </button>
                  <button
                    class="icon-txt task-menu-btn"
                    mat-menu-item
                    (click)="pomodoroRepository.done(item)"
                  >
                    <mat-icon>check_circle_outline</mat-icon>
                    {{ "MarkAsDone" | translate }}
                  </button>
                </mat-menu>
              </div>
              <div class="clearfix"></div>
            </div>
            <!-- .task -->
          </div>
        </ng-container>
      </div>
      <!-- .todolist -->
      <div class="todo_footer">
        <span
          class="todo_footer"
          *ngIf="pomodoroRepository.getAllToDoPomodoro() > 3"
        >
          <i class="icon-coffee-togo"></i>
          {{ "NextLongBreak" | translate }}
          {{ pomodoroRepository.getNextLongBreakTime() }}
          |
        </span>
        <i class="icon-clock"></i>{{ "FinishTime" | translate }} :
        {{
          pomodoroRepository.getPomoToDoDoneTime(pomodoroRepository.getLast())
        }}
      </div>
      <div class="help_footer">
        {{ "mainPageInfo1" | translate }}
        <!--      </div>-->
      </div>
      <!-- TO DO Section -->
      <div id="done">
        <div class="main_title">
          <i class="icon-clipboard-check"></i>{{ "DoneList" | translate }} |
          <span
            >{{ DoneCounter() }}
            /
            <ng-container *ngIf="!haveToken">
              {{ pomodoroRepository.getSumOfDurationsDone() }}
            </ng-container>
            <ng-container *ngIf="haveToken">
              {{ pomodoroRepository.finalDone }}
            </ng-container>
          </span>
        </div>
        <div class="donelist">
          <div class="header_task">
            <div class="col_task col_task1">
              <i class="icon-list-ul"></i>{{ "Category" | translate }}
            </div>
            <div class="col_task col_task2">
              <i class="icon-bookmark"></i>{{ "ShortDescription" | translate }}
            </div>
            <div class="clearfix"></div>
          </div>
          <!-- .task -->
          <div>
            <!--          <div class="task" *ngFor="let item of pomodoroRepository.getDonePomodorosReverse()">-->
            <div
              class="task"
              *ngFor="let item of pomodoroRepository.getDonePomodoros()"
            >
              <div class="col_task col_task1">{{ item.category }}</div>
              <div class="col_task col_task2 col_done_task2">
                {{ item.description }}
              </div>
              <div
                class="col_task col_task3"
                title="{{ 'TaskFinishTime' | translate }}"
              >
                {{ item.ended_at.substr(10, 6) }}
              </div>
              <div class="col_task col_task4">
                <div
                  class="count_pomodoro"
                  (click)="pomodoroRepository.copyToTodo(item)"
                >
                  <span class="material-icons mato-font"> refresh </span>
                </div>
              </div>
              <div class="col_task col_task5">
                <button
                  [matMenuTriggerFor]="menuu"
                  class="more_option_button"
                  title="{{ 'OpenMenu' | translate }}"
                >
                  <i class="icon-ellipsis-h-alt"></i>
                </button>
                <mat-menu #menuu="matMenu">
                  <button mat-menu-item (click)="removeItemFromDone(item)">
                    <mat-icon>delete_forever</mat-icon>
                    <span class="icon-txt">{{ "DeleteTask" | translate }}</span>
                  </button>
                  <button
                    class="icon-txt"
                    mat-menu-item
                    (click)="pomodoroRepository.copyToTodo(item)"
                  >
                    <mat-icon>check_circle_outline</mat-icon>
                    {{ "MarkAsTodo" | translate }}
                  </button>
                </mat-menu>
              </div>
              <div class="clearfix"></div>
            </div>
            <!-- .task -->
          </div>
        </div>
        <!-- .todolist -->
      </div>
      <!-- Done Section -->
    </div>
    <!-- .container -->
  </div>
  <!-- #main_app -->
  <app-footer></app-footer>
</div>
